import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";
import PropertiesCarusel from "@/components/PropertiesCarusel";

import { mapGetters } from "vuex";

import { CLAIMED_PROPERTIES } from "../../../gql/UserProfileQueries";

export default {
  name: "claimed-homes",

  data() {
    return {
      userId: null,
      properties: [],
      interestingProperties: {},
      loadedProperties: false,
      skipInterestingPropertiesQuery: true,

      perPage: 10,
      page: 1
    };
  },

  props: [],

  apollo: {
    claimedProperties: {
      query: CLAIMED_PROPERTIES,
      fetchPolicy: "no-cache",
      variables() {
        return {
          userId: this.userId,
          page: this.page,
          perPage: this.perPage
        };
      },
      skip() {
        return this.skipInterestingPropertiesQuery;
      },
      result({ data: { claimedProperties } }) {
        this.properties = this.properties.concat(claimedProperties.entities);

        this.skipInterestingPropertiesQuery = true;
        this.loadedProperties = true;
      }
    }
  },

  mounted: function() {
    if (this.$route.params.id) {
      this.userId = this.$route.params.id;
    } else {
      this.userId = this.currentUser.id;
    }

    this.skipInterestingPropertiesQuery = false;
  },

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    computedClaimedProperties() {
      let collectProperties = [];

      if (this.properties) {
        collectProperties = this.properties.map(p => {
          return p.property;
        });
      }
      return collectProperties;
    }
  },

  methods: {
    handleNextPage() {
      this.page += 1;
      this.skipInterestingPropertiesQuery = false;
    }
  },

  components: {
    LoadingIcon,
    PropertiesCarusel
  }
};
